export default "__VITE_ASSET__DvbuYLdm__"